import { z } from "zod";

/**
 * Column-binding primitives used by the in-memory custom CSV report feature
 * (services/spock/src/mastra/tools/reporting/inMemoryCsv). Each column is
 * either a fixed static value or a dynamic `{{token}}` pattern resolved at
 * generation time against the row context (check / worker / company / line).
 */
export const templatedReportColumnBindingStaticSchema = z.object({
  columnIndex: z.number().int().min(0),
  bindingKind: z.literal("static"),
  value: z.string(),
  /**
   * When true, the binding only emits its value on the first row of each
   * grouping (default group key = paystub_id). Subsequent rows in the same
   * group emit "". Used for QuickBooks-style transaction headers (Trans #,
   * Type, Date, Num) that should appear once per check, not on every line.
   */
  firstInGroupOnly: z.boolean().optional(),
});

export const templatedReportColumnBindingDynamicSchema = z.object({
  columnIndex: z.number().int().min(0),
  bindingKind: z.literal("dynamic"),
  pattern: z.string().min(1),
  firstInGroupOnly: z.boolean().optional(),
});

export const templatedReportColumnBindingSchema = z.discriminatedUnion(
  "bindingKind",
  [
    templatedReportColumnBindingStaticSchema,
    templatedReportColumnBindingDynamicSchema,
  ]
);

export type TTemplatedReportColumnBinding = z.infer<
  typeof templatedReportColumnBindingSchema
>;
